export interface AgeGroup extends ApiEntity {
  name: string
  order: number
}

export function fetchAgeGroups() {
  return useJsonApiFetch<AgeGroup[]>('/api/v1/age_groups')
}
